import { render, staticRenderFns } from "./taskBoard.vue?vue&type=template&id=6e783341&scoped=true"
import script from "./taskBoard.vue?vue&type=script&lang=js"
export * from "./taskBoard.vue?vue&type=script&lang=js"
import style0 from "./taskBoard.vue?vue&type=style&index=0&id=6e783341&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e783341",
  null
  
)

export default component.exports